import axiosInstance from './config/api';

export interface CallbackHealthResponse {
    pendingTotal: number;
    overdue24hTotal: number;
    avgQueueTimeMilliseconds: number;
}

export const getCallbackHealth = () => {
    const queryParams = new URLSearchParams({
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    return axiosInstance
        .get<CallbackHealthResponse>(`/agent-center/callback-health?${queryParams.toString()}`)
        .then((res) => res.data);
};
